import { Pipe, PipeTransform } from '@angular/core';
import { NUMBER_FORMATS } from '../../helpers/constants';

@Pipe({name: 'tel'})
export class TelephoneNumberPipe implements PipeTransform {
  transform(value: string): string {
    if (NUMBER_FORMATS.some(format => format.test(value))) {
      if (value.charAt(0) === '0') {
        return '+234' + value.substring(1);
      }
      return '+234' + value;
    }
    return value;
  }
}

export { NUMBER_FORMATS }
